import { useCallback, useEffect, useState } from "react";
import { getStablesWithdrawChains } from "../Services/stablesApi";

export const useStablesWithdrawChains = () => {
  const [chains, setChains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await getStablesWithdrawChains();
      if (!result.length) throw new Error("Empty chains");
      setChains(result);
    } catch (err) {
      setChains([]);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { chains, loading, error, reload: load };
};
